const HEIGHTS = [124, 88, 66];
const COLORS = ["var(--spark-gold)", "var(--spark-silver)", "var(--spark-bronze)"];

export interface Leader {
  name: string;
  points: number;
}

/** Second, first, third — so the winner stands in the middle. */
export function Podium({ leaders }: { leaders: Leader[] }) {
  if (!leaders.length || leaders[0].points <= 0) return null;

  const top = leaders.slice(0, 3);
  const order = [1, 0, 2].filter((i) => i < top.length);

  return (
    <div
      style={{
        display: "flex",
        gap: 14,
        alignItems: "flex-end",
        justifyContent: "center",
        marginBottom: 40,
      }}
    >
      {order.map((rank) => (
        <div
          key={top[rank].name}
          style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}
        >
          <span style={{ fontSize: 15, fontWeight: 600 }}>{top[rank].name}</span>
          <span style={{ fontSize: 26, fontWeight: 300, color: "var(--text-secondary)" }}>
            {top[rank].points}
          </span>
          <div
            style={{
              width: 96,
              height: HEIGHTS[rank],
              borderRadius: "14px 14px 0 0",
              background: COLORS[rank],
              display: "flex",
              justifyContent: "center",
              paddingTop: 10,
              color: "#fff",
              fontWeight: 700,
              fontSize: 18,
              transformOrigin: "bottom",
              animation: `riseUp 520ms var(--ease-default) ${rank * 90}ms both`,
            }}
          >
            {rank + 1}
          </div>
        </div>
      ))}
    </div>
  );
}
